import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProfileImages, CommonImages } from "../../../../reusableUI/images";
import { FaArrowLeft } from "react-icons/fa";
import { logoutAuthentication } from "../../../../Service/apiURL";

const roles = [
  {
    label: "Hospital",
    image: CommonImages.hospital,
  },
  {
    label: "Agency",
    image: CommonImages.agency,
  },
  {
    label: "Company",
    image: CommonImages.company,
  },
];

const Role = () => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState("Hospital");

  const handleSelect = (role) => {
    setSelectedRole(role);
  };

  const handleDone = async () => {
    if (!selectedRole) {
      alert("Please select an organization type.");
      return;
    }
    await logoutAuthentication({ redirect: false });
    navigate("/enquiries", { state: { enquiryRole: selectedRole } });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#F3F6F5] font-poppins px-20">
      <div
        className="absolute top-6 left-6 text-blue-600 hover:text-blue-800"
        onClick={() => navigate("/partner")}
      >
        <img
          src={ProfileImages.prev}
          alt="Logo"
          className="w-4 h-4 mb-6 cursor-pointer"
        />
      </div>
      <img src={CommonImages.CevIcon} alt="Logo" className="w-32 mb-6" />{" "}
      <div className="bg-white p-8  rounded-2xl shadow-md w-[55%] text-center py-24">
        <h2 className="text-lg font-semibold text-[#504EFF] mb-6">
          We are a/an
        </h2>
        <div className="flex justify-center gap-20 mb-8 pt-10">
          {roles.map(({ label, image }) => (
            <div
              key={label}
              onClick={() => handleSelect(label)}
              className={`flex flex-col items-center cursor-pointer transition-transform duration-300 ${
                selectedRole === label ? "scale-110" : ""
              }`}
            >
              <div
                className={`w-24 h-24 rounded-full overflow-hidden border-4 ${
                  selectedRole === label
                    ? "border-[#504EFF]"
                    : "border-transparent"
                }`}
              >
                <img
                  src={image}
                  alt={label}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="mt-2 text-sm text-gray-700">{label}</span>
            </div>
          ))}
        </div>
        <button
          onClick={handleDone}
          className="bg-custom-gradient cursor-pointer text-white px-6 py-1.5 rounded-md hover:bg-blue-700 transition mt-8"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Role;
